/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { getSuggestedTrainings, showModal, getTrainingDetail } from "actions";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { Accordion, Card } from "react-bootstrap";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import Helpers from "util/helpers";

class SuggestedTrainings extends Component {
  state = {
    selectedUserId: null,
    employees: [],
    filteredEmployees: [],
    selectedTrainingDetail: null,
    limitedAccess: localStorage.getItem("uilmt") === "true",
  };

  componentDidMount = () => {
    this.fetchData();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      let searchTerm = this.props.searchTerm;
      const filteredData = this.state.employees.filter((z) => {
        const employeeResult = Helpers.getTurkishCharaterFixedList(
          z.employee.name
        ).includes(Helpers.getTurkishCharaterFixedList(searchTerm));

        if (employeeResult) return true;

        const trainingResult =
          z.trainings.filter((b) =>
            Helpers.getTurkishCharaterFixedList(b.training.name).includes(
              Helpers.getTurkishCharaterFixedList(searchTerm)
            )
          ).length > 0;
        return trainingResult;
      });
      this.setState({ filteredEmployees: filteredData });
    }
  }

  fetchData = () => {
    this.props.getSuggestedTrainings(
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = (res) => {
    this.setState({
      employees: res.data.employees,
      filteredEmployees: res.data.employees,
    });
  };
  onError = (err) => {
    this.props.onProcessEnd();
    console.log(err);
  };

  openTrainingDetailModal = (training) => {
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: <TrainingDetailModal training={training} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  handleEventSelected = (employeeId, trainingId) => {
    if (this.state.limitedAccess) return;

    let training = this.state.filteredEmployees
      .filter((z) => z.employee.id === employeeId)[0]
      .trainings.filter((z) => z.training.id === trainingId)[0];
    this.openTrainingDetailModal(training);
  };

  handleAccordionToggle = (eventkey) => {
    const currentUser = this.state.selectedUserId;
    if (currentUser === eventkey) this.setState({ selectedUserId: null });
    else {
      this.setState({ selectedUserId: eventkey });
    }
  };

  renderCardTitle = (emp) => {
    let color = "red";
    if (51 <= emp.qualification && emp.qualification < 76) color = "orange";
    if (emp.qualification >= 76) color = "green";
    return (
      <>
        <div
          id="statusCalendarChart_1"
          className="statusCalendarChart"
          data-percent={emp.qualification}
        >
          <div>
            <div className="single-chart">
              <svg viewBox="-2 -2 40 40" className={`circular-chart ${color}`}>
                <path
                  className="circle-bg"
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <path
                  className="circle"
                  strokeDasharray={`${emp.qualification}, 100`}
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <text x="18" y="22.35" className="percentage">
                  {emp.qualification}
                </text>
              </svg>
            </div>
          </div>
        </div>
        <div className="statusCalendarChartTitle">{emp.employee.name}</div>
      </>
    );
  };

  renderTrainings = (employeeId) => {
    const trainings = this.state.filteredEmployees.find((emp) => {
      return emp.employee.id === employeeId;
    })?.trainings;

    if (trainings) {
      return trainings.map((t) => {
        return (
          <div
            key={t.training.id}
            className="innerDetail"
            onClick={() => this.handleEventSelected(employeeId, t.training.id)}
          >
            {t.training.name}
          </div>
        );
      });
    }
  };

  renderUsers = () => {
    if (this.state.employees.length === 0)
      return <div>{this.props.spinner}</div>;
    return this.state.filteredEmployees.map((emp) => {
      return (
        <div
          key={emp.employee.id}
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        >
          <div className="accordion takvimAccordion">
            <Card key={emp.employee.id}>
              <Card.Header>
                <Accordion.Toggle
                  as="h2"
                  className="mb-0"
                  eventKey={emp.employee.id}
                  onClick={() => this.handleAccordionToggle(emp.employee.id)}
                >
                  <button
                    //   className={this.state.toggledClassnames[`${categoryId}_${idx}`]}
                    className="btn btn-link yonetimTakvimBaslik collapsed"
                    type="button"
                  >
                    {this.renderCardTitle(emp)}
                  </button>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={emp.employee.id}>
                <Card.Body>{this.renderTrainings(emp.employee.id)}</Card.Body>
              </Accordion.Collapse>
            </Card>
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <Accordion activeKey={this.state.selectedUserId} defaultActiveKey="0">
        {this.renderUsers()}
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    calendar: state.calendar.data.calendarItems,
  };
};

export default connect(mapStateToProps, {
  getSuggestedTrainings,
  showModal,
  getTrainingDetail,
})(containsLongRunningProcess(SuggestedTrainings));
